import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Modal, Button } from 'react-bootstrap';
import Swal from 'sweetalert2';
import Select from 'react-select';
import 'flatpickr/dist/flatpickr.min.css';

import { useNavigate } from 'react-router-dom';
import { globalErrorHandler } from '../../../utils/GlobalErrorHandler';
import { userTypeOptions } from '../../../utils/constants';

const Guest = () => {
    const navigate = useNavigate();
    const debounceTimeout = useRef(null);

    const [guests, setGuests] = useState([]);
    const [properties, setProperties] = useState([]);
    const [floors, setFloors] = useState([]);
    const [rooms, setRooms] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [pagination, setPagination] = useState({ page: 1, limit: 10, total: 0, totalPages: 1 });

    const [showAssignRoleModal, setShowAssignRoleModal] = useState(false);
    const [showAssignPropertyModal, setShowAssignPropertyModal] = useState(false);

    const [role, setRole] = useState(null);
  //  const [selectedUserId, setSelectedUserId] = useState(null);
        const [selectedUserId, setSelectedUserId] = useState(null);

    const [selectedUserProperties, setSelectedUserProperties] = useState([]);
    const [filter, setFilter] = useState({ guest_name: '', property_id: '', floor_id: '', room_id: '' });

    // Fetch guests
   const getGuests = async () => {
    setIsLoading(true);
    try {
        const res = await axios.get(
            `${process.env.REACT_APP_WEB_SERVICES_URL}/admin/get-current-guests`,
            {
                params: { ...filter, page: pagination.page, limit: pagination.limit },
                withCredentials: true
            }
        );

        if (res.data.status) {
            const normalizedGuests = (res.data.guests || []).map(g => ({
                ...g,
                assigned_properties:
                    typeof g.assigned_properties === 'string'
                        ? JSON.parse(g.assigned_properties || '[]')
                        : Array.isArray(g.assigned_properties)
                            ? g.assigned_properties
                            : []
            }));

            setGuests(normalizedGuests);
            setPagination(res.data.pagination);
        } else {
            setGuests([]);
        }
    } catch (error) {
        globalErrorHandler(error, navigate);
    } finally {
        setIsLoading(false);
    }
};



    useEffect(() => { getProperties(); getFloors(); getRooms(); }, []);
    useEffect(() => {
        if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
        debounceTimeout.current = setTimeout(getGuests, 500);
        return () => clearTimeout(debounceTimeout.current);
    }, [pagination.page, filter]);

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilter(prev => {
            const updated = { ...prev, [name]: value };
            if (name === "property_id") { updated.floor_id = ""; updated.room_id = ""; setFloors([]); setRooms([]); getFloors(value); }
            else if (name === "floor_id") { updated.room_id = ""; setRooms([]); getRooms(value); }
            return updated;
        });
        setPagination(prev => ({ ...prev, page: 1 }));
    };

    const assignRole = async () => {
        try {
            await axios.post(`${process.env.REACT_APP_WEB_SERVICES_URL}/admin/assign-role`, { user_id: selectedUserId, role }, { withCredentials: true });
            Swal.fire('Success', 'Role updated.', 'success');
            setShowAssignRoleModal(false);
            getGuests();
        } catch (error) { globalErrorHandler(error, navigate); }
    };

    const assignProperties = async () => {
        try {
            await axios.post(`${process.env.REACT_APP_WEB_SERVICES_URL}/admin/assign-properties`, {
                user_id: selectedUserId,
                property_ids: selectedUserProperties.map(p => p.value)
            }, { withCredentials: true });
            Swal.fire('Success', 'Properties assigned.', 'success');
            setShowAssignPropertyModal(false);
            setSelectedUserProperties([]);
            getGuests();
        } catch (error) { globalErrorHandler(error, navigate); }
    };

    const clearFilter = () => { setFilter({ guest_name: '', property_id: '', floor_id: '', room_id: '' }); setPagination(prev => ({ ...prev, page: 1 })); };
    const getProperties = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_WEB_SERVICES_URL}/admin/get-properties`, { withCredentials: true });
            if (res.data.status) setProperties(res.data.properties || []);
        } catch (error) { globalErrorHandler(error, navigate); }
    };
    const getFloors = async (propertyId) => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_WEB_SERVICES_URL}/admin/get-floors?property_id=${propertyId}`, { withCredentials: true });
            if (res.data.status) setFloors(res.data.floors || []);
        } catch (error) { globalErrorHandler(error, navigate); }
    };
    const getRooms = async (floorId) => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_WEB_SERVICES_URL}/admin/get-rooms?floor_id=${floorId}`, { withCredentials: true });
            if (res.data.status) setRooms(res.data.rooms || []);
        } catch (error) { globalErrorHandler(error, navigate); }
    };

    return (
        <div className="container-fluid px-4 mt-4">
            <div className="d-flex justify-content-between align-items-center mb-3"><h3>Assign Roles</h3></div>

            <div className="card shadow mt-4">
                <div className="card-header"><h5 className="mb-0">Search Guests</h5></div>
                <div className="card-body p-4">
                    {/* Filter Section */}
                    <div className="row align-items-end g-2 mb-4">
                        <div className="col-md-3">
                            <input type="text" className="form-control ps-3 pe-5 rounded-3" placeholder="Search Guest" name="guest_name" value={filter.guest_name} onChange={handleFilterChange} />
                        </div>
                        <div className="col-md-3">
                            <select className="form-select rounded-3" name="property_id" value={filter.property_id} onChange={handleFilterChange}>
                                <option value="">Select Property</option>
                                {properties.map(p => <option key={p.id} value={p.id}>{p.property_name}</option>)}
                            </select>
                        </div>
                        <div className="col-md-3"><select className="form-select rounded-3" name="floor_id" value={filter.floor_id} onChange={handleFilterChange}><option value="">Select Floor</option>{floors.map(f => <option key={f.id} value={f.id}>{f.floor_name}</option>)}</select></div>
                        <div className="col-md-2"><select className="form-select rounded-3" name="room_id" value={filter.room_id} onChange={handleFilterChange}><option value="">Select Room</option>{rooms.map(r => <option key={r.id} value={r.id}>{r.room_no}</option>)}</select></div>
                        <div className="col-md-1"><button className="btn btn-dark w-100 rounded-3" onClick={clearFilter}>Clear</button></div>
                    </div>

                    {/* Guest Table */}
                    <div className="table-responsive">
                        <table className="table table-bordered table-hover shadow-sm nowrap">
                            <thead className="table-success">
                                <tr>
                                    <th>Guest ID</th>
                                    <th>Name</th>
                                    <th>Contact Info</th>
                                    <th>Bed</th>
                                    <th>Floor</th>
                                    <th>Property</th>
                                    <th>Current Role</th>
                                    <th>Assigned Properties</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading ? (<tr><td colSpan="9">Loading...</td></tr>) :
                                    guests.length === 0 ? (<tr><td colSpan="9">No data found.</td></tr>) :
                                        guests.map(g => (
                                            <tr key={g.id}>
                                                <td>{`BBM${String(g.id).padStart(4, '0')}`}</td>
                                                <td>{g.name}</td>
                                                <td>{`${g.phone || ''} ${g.email}`}</td>
                                                <td>{g.bedtype}</td>
                                                <td>{g.floor_name}</td>
                                                <td>{g.property_name}</td>
                                                <td>{userTypeOptions.find(opt => opt.role === g.role)?.label || g.role}</td>
                                               
                                               <td>
  {g.assigned_properties?.length ? (
    <div className="d-flex flex-wrap gap-1">
      {g.assigned_properties.map(p => (
        <span key={p.value} className="">
          {p.label}
        </span>
      ))}
    </div>
  ) : (
    '-'
  )}
</td>

                                                <td className="text-center d-flex justify-content-start gap-1">
                                                    <Button variant="success" size="sm" onClick={() => { setRole(g.role); setSelectedUserId(g.user_id); setShowAssignRoleModal(true); }}>Assign Role</Button>
                                                    {(g.role === "manager" || g.role === "overseer") && (
                                                        <Button variant="primary" size="sm" onClick={() => { setSelectedUserId(g.user_id); setSelectedUserProperties(g.assigned_properties || []); setShowAssignPropertyModal(true);  }}>Assign Properties</Button>
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination */}
                    <div className="d-flex justify-content-end mt-3">
                        <nav>
                            <ul className="pagination">
                                {[...Array(pagination.totalPages)].map((_, i) => (
                                    <li key={i} className={`page-item ${pagination.page === i + 1 ? 'active' : ''}`}>
                                        <button className="page-link" onClick={() => setPagination(prev => ({ ...prev, page: i + 1 }))}>{i + 1}</button>
                                    </li>
                                ))}
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>

            {/* Assign Role Modal */}
            <Modal show={showAssignRoleModal} onHide={() => setShowAssignRoleModal(false)}>
                <Modal.Header closeButton><Modal.Title>Assign Role</Modal.Title></Modal.Header>
                <Modal.Body>
                    <label className="form-label">Select User Role</label>
                    <select value={role} onChange={(e) => setRole(e.target.value)} className="form-select rounded-3">
                        <option value="">-- Select --</option>
                        {userTypeOptions.map(opt => <option key={opt.role} value={opt.role}>{opt.label}</option>)}
                    </select>
                </Modal.Body>
                <Modal.Footer>
                    <Button className="w-100" onClick={() => { assignRole(); setSelectedUserId(null); }}>Save</Button>
                </Modal.Footer>
            </Modal>

            {/* Assign Properties Modal */}
            <Modal show={showAssignPropertyModal} onHide={() => setShowAssignPropertyModal(false)}>
                <Modal.Header closeButton><Modal.Title>Assign Properties</Modal.Title></Modal.Header>
                <Modal.Body>
                    <label className="form-label">Select Properties</label>
                    <Select
                        isMulti
                        options={properties.map(p => ({ value: p.id, label: p.property_name }))}
                        value={selectedUserProperties}
                        onChange={setSelectedUserProperties}
                        classNamePrefix="react-select"
                        placeholder="Select properties"
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button className="w-100" onClick={assignProperties}>Save</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default Guest;
